import axios from 'axios';
import { getApiUrl } from '../config/apiConfig';

export interface LoginResponse {
  success: boolean;
  data?: {
    token: string;
    user: {
      _id: string;
      username: string;
      email: string;
      stats?: {
        gamesPlayed: number;
        gamesWon: number;
        totalPlayTime: number;
      };
    };
  };
  error?: string;
}

export interface RegisterResponse {
  success: boolean;
  data?: {
    token: string;
    user: any;
  };
  error?: string;
}

class AuthService {
  private token: string | null = null;

  constructor() {
    this.token = localStorage.getItem('token');
  }

  async login(username: string, password: string): Promise<LoginResponse> {
    try {
      const response = await axios.post(getApiUrl('/api/auth/login'), {
        username,
        password
      });

      if (response.data.success) {
        this.token = response.data.data.token;
        localStorage.setItem('token', this.token || '');
        localStorage.setItem('userId', response.data.data.user._id);
        localStorage.setItem('username', response.data.data.user.username);
      }

      return response.data;
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || '登录失败'
      };
    }
  }

  async register(username: string, email: string, password: string): Promise<RegisterResponse> {
    try {
      const response = await axios.post(getApiUrl('/api/auth/register'), {
        username,
        email,
        password
      });

      if (response.data.success) {
        this.token = response.data.data.token;
        localStorage.setItem('token', this.token || '');
        localStorage.setItem('userId', response.data.data.user._id);
        localStorage.setItem('username', response.data.data.user.username);
      }

      return response.data;
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || '注册失败'
      };
    }
  }

  getToken(): string | null {
    return this.token || localStorage.getItem('token');
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  logout(): void {
    this.token = null;
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
  }

  getCurrentUser(): { username: string; userId: string } | null {
    const username = localStorage.getItem('username');
    const userId = localStorage.getItem('userId');
    return username && userId ? { username, userId } : null;
  }
}

export const authService = new AuthService();
